var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ActiveChatsPanel.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e48e4454\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ActiveChatsPanel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Chatroom/ActiveChatsPanel.vue
// module id = 361
// module chunks = 1